<div class="rooms-groups-table">
    <ev-grid-table [gridModel]="displayTemplate">

        <ev-th>
            @for (column of headers; track $index) {
                @if (column.isSortable) {
                    <ev-td
                        [area]="column.prop"
                        (click)="updateSort(column.prop)"
                        [isSelectable]="true"
                        [textAlignment]="column.textAlignment ?? 'left'"
                        [selected]="sortConfig().sortOption.prop === column.prop"
                    >
                        {{ column.name.toUpperCase() }}
                    </ev-td>
                } @else {
                    <ev-td [area]="column.prop" [textAlignment]="column.textAlignment ?? 'left'">
                        {{ column.name.toUpperCase() }}
                    </ev-td>
                }
            }
        </ev-th>

        @for (rowData of tableData(); track rowData.groupKeyValue) {
            <ev-tr class="ev-row">
                <ev-td area="groupKeyValue" header="Rom" column [fontBold]="sortConfig().sortOption.prop === 'groupKeyValue'">
                    <div class="column-data">
                        {{ rowData.groupKeyValue }} r
                        @if (rowData.subValueDisplay?.min && rowData.subValueDisplay?.max) {
                            {{ rowData.subValueDisplay.min }} → {{ rowData.subValueDisplay.max }}
                        } @else if (rowData.subValueDisplay?.min) {
                            {{ rowData.subValueDisplay.min }} →
                        } @else if (rowData.subValueDisplay?.max) {
                            → {{ rowData.subValueDisplay.max }}
                        }
                    </div>
                </ev-td>
                <ev-td area="total" header="Tot" column textAlignment="right" [fontBold]="sortConfig().sortOption.prop === 'total'">
                    <div class="column-data">{{ rowData.total?.numberOfUnits }}</div>
                </ev-td>
                <ev-td area="sold" header="Solgt" column textAlignment="right" [fontBold]="sortConfig().sortOption.prop === 'sold'">
                    <div class="column-data">{{ rowData.sold?.numberOfUnits }}</div>
                </ev-td>
                <ev-td area="unsold" header="Usolgt" column textAlignment="right" [fontBold]="sortConfig().sortOption.prop === 'unsold'">
                    <div class="column-data">{{ rowData.unsold?.numberOfUnits }}</div>
                </ev-td>
            </ev-tr>
        }
    </ev-grid-table>
</div>
